export function validateBrandCore(brandCore) {
  const errors = {};

  if (!brandCore.name || brandCore.name.trim().length < 1) {
    errors.name = 'Brand name is required';
  } else if (brandCore.name.length > 100) {
    errors.name = 'Brand name must be 100 characters or less';
  }

  if (!brandCore.mission || brandCore.mission.trim().length < 1) {
    errors.mission = 'Mission statement is required';
  } else if (brandCore.mission.length > 280) {
    errors.mission = 'Mission must be 280 characters or less';
  }

  // Vibe keywords are optional, but if provided, validate length
  if (brandCore.vibeKeywords) {
    if (!Array.isArray(brandCore.vibeKeywords)) {
      errors.vibeKeywords = 'Vibe keywords must be an array';
    } else {
      const tooLong = brandCore.vibeKeywords.some(k => k && k.length > 30);
      if (tooLong) {
        errors.vibeKeywords = 'Each keyword must be 30 characters or less';
      }
    }
  }

  return errors;
}

export function validateVisuals(visuals) {
  const errors = {};

  if (!/^#[0-9A-Fa-f]{6}$/.test(visuals.colorSeed)) {
    errors.colorSeed = 'Invalid color format';
  }

  if (!['light', 'dark'].includes(visuals.colorMode)) {
    errors.colorMode = 'Color mode must be light or dark';
  }

  if (!['serif', 'sans', 'mono', 'display', 'rounded', 'elegant'].includes(visuals.fontStyle)) {
    errors.fontStyle = 'Invalid font style';
  }

  return errors;
}

export function validateScales(scales) {
  const errors = {};

  for (const key of ['minimalistDense', 'playfulSerious', 'safeExperimental']) {
    const val = scales[key];
    if (typeof val !== 'number' || val < 0 || val > 100 || !Number.isInteger(val)) {
      errors[key] = 'Scale value must be an integer between 0 and 100';
    }
  }

  return errors;
}

export function validateStep(step, formData) {
  switch (step) {
    case 0:
      return validateBrandCore(formData.brandCore);
    case 1:
      return validateVisuals(formData.visuals);
    case 2:
      return validateScales(formData.scales);
    case 3:
      return {
        ...validateBrandCore(formData.brandCore),
        ...validateVisuals(formData.visuals),
        ...validateScales(formData.scales)
      };
    default:
      return {};
  }
}

export function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}
